<template functional>
  <v-list-item v-bind="data.attrs" v-on="listeners">
    <v-list-item-icon>
      <v-layout row>
        <v-icon :color="$options.color(props)">{{ props.icon }}</v-icon>
      </v-layout>
    </v-list-item-icon>
    <v-input :rules="props.rules" hide-details="auto">
      <v-list-item-content class="pb-0">
        <v-list-item-subtitle :class="$options.textColor(props, 'libelle')"
          >{{ props.adresse.libelle }}
        </v-list-item-subtitle>

        <adresseSpan
          :adresse="props.adresse"
          :itemPath="props.itemPath"
          :analyseDiff="props.analyseDiff"
        />
      </v-list-item-content>
    </v-input>
    <slot name="action" />
  </v-list-item>
</template>

<script>
function color(props, path) {
  if (!props.analyseDiff) {
    return null;
  }

  const c = props.analyseDiff.color[props.itemPath];
  return (
    c || (path ? props.analyseDiff.color[props.itemPath + '.' + path] : null)
  );
}

function textColor(props, path) {
  const c = color(props, path);
  if (c) {
    return `${c}--text`;
  } else {
    return null;
  }
}

export default {
  functional: true,
  props: {
    icon: {
      type: String,
      default: 'mdi-home',
    },
    itemPath: {
      type: String,
      default: '',
    },
    adresse: {
      type: Object,
    },
    rules: {
      type: Array,
    },
    analyseDiff: {
      type: Object,
    },
  },
  color,
  textColor,
};
</script>
